// extracted by mini-css-extract-plugin
export default {"site":"day_site__jW3wd","content":"day_content__hnZJP","spec":"day_spec__tSyy1","comment":"day_comment__eI548","list":"day_list__Q3XKv"};